/**
 * @extends com.inq.flash.client.control.ApplicationController
 * @constructor
 */
com.inq.flash.client.control.CMSDKAppController = function() {
	this.constructor.__super__.call(this);

	// this.attemptingConnection = true;
	// this.queueMessages = true;
	// this.framework.connect();
	this.apiMsgContext = new com.inq.utils.Dictionary();
	this.customerEngaged = false;
	this.seqNo = 0;
	this.minimized = false;


};

$hxClasses.extend(com.inq.flash.client.control.ApplicationController,com.inq.flash.client.control.CMSDKAppController,"com.inq.flash.client.control.CMSDKAppController");

com.inq.flash.client.control.CMSDKAppController.prototype.registerMessageHandlers = function () {
	/*
	 * register all handlers.
	 * Order is important here, specific handlers should be before common.
	 * Example, chat.denied.reconnect should be before chat.denied
	 */
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.CMSDKAcceptedMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ClientAuthDataMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.CMSDKAuthorizedMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.CMSDKDeniedReconnectMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.CMSDKDeniedMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.StateChangeMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.CMSDKExitMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.CMSDKNeedWaitHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.CMSDKTypingActivityHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ChatLineMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.CMSDKCommunicationSurveyMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.CMSDKAutomatonDataMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.CMSDKCommunicationMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.CMSDKTransferResponse());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.CMSDKMemberConnectedMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.CMSDKMemberLostMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.CMSDKOwnerTransferResponseMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.CommandMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.CMSDKCommandMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.CMSDKCobrowseMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ErrorHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.AgentDataPassMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.ContinueTransitionHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.CMSDKSystemMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.CMSDKNinaCoachChatTakeOverMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.CMSDKAutomatonRequestMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.CMSDKUserResponseMessageHandler());
	this.registerHandler(new com.inq.flash.client.control.messagehandlers.AsyncUnauthTokenInfoMessageHandler());

	/**
	 * faked to not to show exception when Cobrowse is turned on from CIAPI
	 * @type {{addAriaMsg: *}}
	 */
	com.inq.aria.AriaMsg = {
		addAriaMsg: $noop()
	};

	com.inq.flash.client.chatskins.SkinControl = this.skinControl = {
		HOUR: 60 * 60 * 1000,
		CLOSE_CHAT_REASON_UNKNOWN: "0",
		CLOSE_CHAT_REASON_CUSTOMER_CLOSED: "4",
		CLOSE_CHAT_REASON_CMSDKDMH: "9",
		CLOSE_CHAT_REASON_CMSDK_EXIT: "13",
		getInitialClickstreamData: function () {
			var streamBuilder = com.inq.flash.client.control.ClickStreamBuilder;
			/** @type {String} */
			var stream = streamBuilder.parseInitialClickstreamData()
				+ streamBuilder.IdentifyPlatform()
				+ streamBuilder.parseURLfromClickStreamData()
				+ streamBuilder.parseDFVfromClickStreamData();
			return stream;
		},
		isClick2WebCall: function () {
			return false;
		},
		agentClosesChat: function () {
			com.inq.flash.client.chatskins.CoBrowseMgr.agentEndsCob();
			Application.application.applicationController.prepareClosing();
			Application.application.applicationController.disable();
			this.startPostChatTimer();
		},
		getOpener: function () {
			return window.parent.opener["inqFrame"];
		},
		showIntroductionAfterPreloadMessages: $noop,
		topicId: null,
		fireCustomEvent: function (eventName, evtDataSupplementFcn) {
			if (eventName == "PrechatSurveyShown") {
				if (com.inq.flash.client.control.PersistenceManager.GetValue(PRE_CHAT_SURVEY_SHOWN) == 1) {
					return;
				}
				com.inq.flash.client.control.PersistenceManager.SetValue(PRE_CHAT_SURVEY_SHOWN, 1);
			} else if (eventName == "PrechatSurveyCompleted") {
				if (com.inq.flash.client.control.PersistenceManager.GetValue(PRE_CHAT_SURVEY_COMPLETED) == 1) {
					return;
				}
				com.inq.flash.client.control.PersistenceManager.SetValue(PRE_CHAT_SURVEY_COMPLETED, 1);
			}
			com.inq.flash.client.control.FlashPeer.fireCustomEvent(eventName, null, null, evtDataSupplementFcn);
		},
		parseConversationTranscript: function (response, callback) {
			var jsonResponse = typeof response == 'string' ? JSON.parse(response) : response;
			var responseData = typeof jsonResponse.data == 'string' ? JSON.parse(jsonResponse.data) : jsonResponse.data;
			if (responseData.conversations) {
				if (responseData.conversations.length > 0) {

					var conversationData = responseData.conversations[responseData.conversations.length - 1];
					com.inq.flash.client.chatskins.SkinControl.topicId = conversationData.topicID;
					com.inq.flash.client.chatskins.SkinControl.topicName = conversationData.topicName;
					com.inq.flash.client.chatskins.SkinControl.conversationActive = conversationData.outcome === "active" || conversationData.outcome === "followup";


					if (com.inq.flash.client.chatskins.SkinControl.conversationActive) {
						var initialConversationCustomerID = responseData.customerID;
						if (initialConversationCustomerID) {
							com.inq.flash.client.control.PersistenceManager.SetValue(INITIAL_CUSTOMER_ID, initialConversationCustomerID);
						}
						var conversationID = conversationData.conversationID;
						if (conversationID) {
							com.inq.flash.client.control.PersistenceManager.SetValue(CONVERSATION_ID, conversationID);
						}
					}
					callback(responseData.conversations)
				} else {
					callback([]);
				}
			} else {
				com.inq.flash.client.chatskins.SkinControl.topicId = responseData.topicID;
				com.inq.flash.client.chatskins.SkinControl.topicName = responseData.topicName;
				com.inq.flash.client.chatskins.SkinControl.conversationActive = responseData.outcome === "active" || responseData.outcome === "followup";
				if (com.inq.flash.client.chatskins.SkinControl.conversationActive) {
					var initialConversationCustomerID = responseData.customerID;
					if (initialConversationCustomerID) {
						com.inq.flash.client.control.PersistenceManager.SetValue(INITIAL_CUSTOMER_ID, initialConversationCustomerID);
					}
					var conversationID = responseData.conversationID;
					if (conversationID) {
						com.inq.flash.client.control.PersistenceManager.SetValue(CONVERSATION_ID, conversationID);
					}
				}
				if (responseData.conversationID) {
					callback([responseData]);
				} else {
					callback([]);
				}
			}
			Application.application.setAsyncLoading(false);
		},
		closeChatOneHourTimer: function (startTimerDate) {
			if (!Application.application.applicationController.getChat().getHasAuthorized()) {
				var currentDate = new Date();
				if (startTimerDate.getTime() < (currentDate.getTime() - this.HOUR)) {
					var appCtrl = Application.application.applicationController;
					if (appCtrl.timeoutCb) {
						appCtrl.timeoutCb();
					}
					appCtrl.closeChat();
				} else {
					setTimeout(function () {
						com.inq.flash.client.chatskins.SkinControl.closeChatOneHourTimer(startTimerDate);
					}, 60 * 2 * 1000);
				}
			}
		},
		clearTranscriptArray: $noop,
		prepareAsyncSurveyMessage: function (messageText, conversationID) {
			if (/(?:launchNativePostChatSurvey)/.test(messageText)) {
				conversationID = conversationID ? conversationID : "";
				messageText = messageText.replace(/href=(?:"|')(.+?)(?:"|')/, function (str, url) {
					/** @type {string} */
					var surveyURL = url + "&conversationID=" + conversationID;
					return 'href="#" ' + "data-survey-url" + '="' + surveyURL + '"';
				});
			}

			return messageText;
		},
		connectionLostClosingChat: function () {
			if (!Application.application.applicationController.isConnected()) {
				return;
			}
			com.inq.flash.client.control.FlashPeer.setDisconnectFlag();
			Application.application.applicationController.disable();
			Application.application.applicationController.prepareClosing();
			if (Application.application.applicationController.failedCb) {
				Application.application.applicationController.failedCb();
			} else if (this.persistentReconnect && !this.preloadMsgComplete) {
				Application.application.applicationController.onPreloadComplete("failed");
			}
		},
		getInitialTimeout: function (timeout) {
			return parseInt(com.inq.utils.Util.getConfig("initialTimeOut", com.inq.flash.client.control.FlashPeer.getInitialTimeout()));
		},
		setupTimeoutTimer: function () {
			/** @type {Number} */
			var nowMs = new Date().getTime();
			/** @type {Number} */
			var chatWindowAppearedMs = com.inq.flash.client.control.PersistenceManager.GetValue(CHAT_WINDOW_APPEARED, 0);
			/** @type {Number} */
			var initialTimeOutSec = this.getInitialTimeout();

			// used at ChatMgr.prototype.onPageLanding to close chat window if
			// chat not engaged and timeout after first chat window appearance.
			// Please see: var initialTimeOut = chatInterfaceData.it;
			if (initialTimeOutSec !== com.inq.flash.client.control.FlashPeer.getInitialTimeout()) {
				com.inq.flash.client.control.PersistenceManager.SetValue("it", initialTimeOutSec, false);
			}

			var timeoutSec;
			if (chatWindowAppearedMs == 0) {
				com.inq.flash.client.control.PersistenceManager.SetValue(CHAT_WINDOW_APPEARED, nowMs, false);
				timeoutSec = initialTimeOutSec;
			} else {
				var durationMs = nowMs - chatWindowAppearedMs;
				/*
				 * timeoutSec should don't be negative because chat
				 * window should not showed by check in ChatMgr#onPageLanding
				 */
				timeoutSec = initialTimeOutSec - durationMs / 1000;
			}
			this.startTimer(timeoutSec);
		},
		startTimer: function (timeoutSec, timeoutAction) {
			if (com.inq.flash.client.control.FlashPeer.isAsyncUnauthUser()) {
				return;
			}
			if (!timeoutAction) {
				timeoutAction = function () {
					clearTimeout(this.timerTimeout);
					// Once engaged this must not called.
					if (!com.inq.flash.client.control.FlashPeer.isOne2ManyChatEnabled()) {
						this.onTimeout();
					}
					this.timerTimeout = null;
				};
			}
			// Initialize timer object
			this.initializeTimerTimeout(timeoutSec, timeoutAction);
		},
		StopTimer: function () {
			if (this.timerTimeout != null) {
				clearTimeout(this.timerTimeout);
				this.timerTimeout = null;
			}
		},
		initializeTimerTimeout: function (timeoutSec, timeoutAction) {
			try {
				if (!timeoutSec) {
					/*  No time out if timeoutSec is not set */
					haxe.Log.trace("Timeout value was not set. Timeout will not occur.");
					return;
				} else {
					var maxTimeOut = Math.pow(2, 32) - 1;
					/* isNaN check should come first or it always return false */
					if (isNaN(timeoutSec) || timeoutSec < 0 || timeoutSec > maxTimeOut) {
						haxe.Log.trace(
							"Default time out is used if timeoutSec is negative, it is bigger than maxTimeOut, or it is a NaN"
						);
						timeoutSec = com.inq.flash.client.control.FlashPeer.getInitialTimeout();
					}
					this.timerTimeout = setTimeout(timeoutAction.bind(this), timeoutSec * 1000);
				}
			} catch (msg) {
			}

			this.timeoutTime = timeoutSec;
			this.timeoutAction = timeoutAction;
		},
		onTimeout: function () {
			this.StopTimer();
			var appCtrl = Application.application.applicationController;
			if (appCtrl.timeoutCb) {
				appCtrl.timeoutCb();
			}
			appCtrl.closeChat();
		},
		executeCustomCommand: function (commandParam) {
			return com.inq.flash.client.control.FlashPeer.executeCustomCommand(commandParam);
		},
		PushToFrameset: function (_sUrl, _sTarget) {
			try {
				/** @type {String} */
				var myURL = com.inq.flash.client.control.FlashPeer.getClientPageURL();
				/** @type {String} */
				var destURL = HxOverrides.substr(_sUrl, _sUrl.length - 1, null) != "/" ? _sUrl : HxOverrides.substr(_sUrl, 0, _sUrl.length - 1);
				myURL = HxOverrides.substr(myURL, myURL.length - 1, null) != "/" ? myURL : HxOverrides.substr(myURL, 0, myURL.length - 1);
				if (_sTarget.toLowerCase() == "_self" && myURL.toLowerCase() == destURL.toLowerCase()) {
					haxe.Log.trace("SkinControl.PushToFrameset: already at target URL", {
						fileName: "SkinControl.hx",
						lineNumber: 801,
						className: "com.inq.flash.client.chatskins.SkinControl",
						methodName: "PushToFrameset"
					});
					return;
				}

				com.inq.flash.client.control.FlashPeer.PushToFrameset(destURL, _sTarget);
			} catch (e) {
				if (js.Boot.__instanceof(e, Error)) {

					com.inq.flash.client.chatskins.XTrace.StackTrace("SkinControl.PushToFrameset:" + Std.string(e), "error");
				} else throw(e);
			}
		},
		startPostChatTimer: function () {
			this.startTimer(
				this.getPostChatTimeout(),
				function () {
					this.StopTimer();
					this.closeChat();
				}.bind(this)
			);
		},
		getPostChatTimeout: function () {
			return parseInt(com.inq.utils.Util.getConfig("postChatTimeOut", 60 * 60));
		},
		AddTranscriptItemToChatWindow: $noop(),
		getIsPersistentChat: function () {
			return com.inq.flash.client.control.FlashPeer.isPersistentWindow();
		},
		isClick2call: function () {
			return false;
		},
		actionBtnCloseChat: function () {
			Application.application.applicationController.closeChat();
		},
		isContinued: function () {
			return !!com.inq.flash.client.control.FlashVars.isContinued();
		},
		closeChat: function () {
			com.inq.flash.client.control.FlashPeer.closeChat(
				Application.application.applicationController.isConnected()
			);
		}
	};

	com.inq.flash.client.control.MinimizeManager = {
		count:0,
		isMinimized: function() {
			this.count = com.inq.flash.client.control.PersistenceManager.GetValue(MINIMIZED_COUNT,-1);
			return Application.application.applicationController.minimized ||  this.count != -1;
		},
		lastAgentMessage:function() {
			if (this.isMinimized()) {
				this.count++;
				com.inq.flash.client.control.PersistenceManager.SetValue(MINIMIZED_COUNT, this.count);
			}
		},
		restore:function() {
			com.inq.flash.client.control.PersistenceManager.SetValue(MINIMIZED_COUNT, -1);
			this.count = 0;
		},
		reset:function() {
			com.inq.flash.client.control.PersistenceManager.SetValue(MINIMIZED_COUNT, 0);
			this.count = 0;
		},
		actionMinimize:function() {
		},
		actionRestore:function() {
		}
	};

	com.inq.ui.Container = {
		_getElementById : function(id,doc) {
			if (doc == null) {
				doc = window.document;
			} else {
				if (doc == window.parent.document && window.getParentElByIDTFacade) {
					return window.getParentElByIDTFacade(id);
				}
			}
			return doc.getElementById(id);
		}
	};

	com.inq.flash.client.control.FlashPeer.setCiFunction("ciActionBtnCloseChat", com.inq.flash.client.chatskins.SkinControl.actionBtnCloseChat);

};

com.inq.flash.client.control.CMSDKAppController.prototype.connectionEstablished = function() {
	com.inq.flash.client.control.FlashPeer.setCABeacon(this.chat.BEACON_ACTIVATE);
	this.wasConnected = true;
	var message = null;
	if (!Boolean(com.inq.flash.client.control.FlashVars.isContinued())
		|| com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT,0) == 0) {
		message = new com.inq.flash.client.data.ChatRequestMessage(this.chat,com.inq.flash.client.control.FlashPeer.isPersistentWindow(),this.agentID,0, this, this.chat.isAsyncReconnect());

		this.sendMessage(message, this.engageChatSuccess.bind(this),this.engageChatError.bind(this));
	} else if (this.isAgentAssigned()) {
		this.setConnectionAccepted(true);
	}

	if(this.persistentReconnect) {
		this.playQueueMessages();
		this.queueMessages = false;
	}
};

com.inq.flash.client.control.CMSDKAppController.prototype.setAgentConfig = function(agentID, eventData, coBrowseEnabled, buID, agentGroupID){
	if(coBrowseEnabled == null) coBrowseEnabled = false;
	this.agentID = agentID;
	this.setFlagChatInQueue(false);
	this.chat.setAgentGroupID(agentGroupID);
	this.chat.setBusinessUnitID(buID);
	com.inq.flash.client.control.FlashPeer.setAgentConfig(agentID,coBrowseEnabled,eventData,buID,agentGroupID);
};

com.inq.flash.client.control.CMSDKAppController.prototype.engage = function(initialMessage, autoConnect, engageParams, callback) {
	if (!Boolean(com.inq.flash.client.control.FlashVars.isContinued())
		|| com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT,0) == 0) {
		this.waitingToExitChat = false;
		if (this.intentionalDisconnect) {
			this.wasConnected = false;
			this.intentionalDisconnect = false;
			com.inq.flash.client.control.PersistenceManager.reopen();
			this.framework.enableForReEngaging();
		}
		if (engageParams) {
			this.setEngageParameters(engageParams);
		}
		this.setApiContext(com.inq.flash.client.data.MessageFields.TYPE_CHAT_REQUEST, {text:initialMessage, cb:callback, autoConnect:autoConnect, params:engageParams});
		this.attemptingConnection = true;
		this.intentionalDisconnect = false;
		this.queueMessages = true;
		this.framework.connect();
	}
};

com.inq.flash.client.control.CMSDKAppController.prototype.engageChatSuccess = function(event) {
	var type = com.inq.flash.client.data.MessageFields.TYPE_CHAT_REQUEST;
	com.inq.flash.client.control.PersistenceManager.SetValue(CHAT_ENGAGED, true, false, true);
	com.inq.flash.client.chatskins.SkinControl.StopTimer();
	var contextObj = this.getApiContext(type);
	if (contextObj) {
	    var response = {
            "messageType": type,
            "statusType": event.type,
            "httpStatus": event.target.responseStatus,
            "asyncReconnect": this.chat.isAsyncReconnect(),
            "windowId": com.inq.flash.client.control.FlashVars.getWindowId()
        };

		if (contextObj.autoConnect) {
			var message = new com.inq.flash.client.data.ChatEngageMessage(this.chat, contextObj.text, contextObj.params && contextObj.params.clientOutcome || "", this.getAgentAlias());
			this.sendText(message);
		} else if (this.isAutomatonMode() && this.autoConnectedCb) {
			this.autoConnectedCb(response);
			return;
		} else if (contextObj.text) {
			this.sendText(this.getMessage(contextObj.text, 0));
		}
		if (contextObj.cb) {
			contextObj.cb(response);
		}
	}
};

com.inq.flash.client.control.CMSDKAppController.prototype.engageChatError = function (event) {
	var type = com.inq.flash.client.data.MessageFields.TYPE_CHAT_REQUEST;
	var contextObj = this.getApiContext(type);
	if (contextObj && contextObj.cb) {
		contextObj.cb(
		    {
                "messageType": type,
                "statusType": event.type,
                "httpStatus": event.target.responseStatus
		    }
		)
	}
};

com.inq.flash.client.control.CMSDKAppController.prototype.setApiContext = function(key, contextObj) {
	this.lastApiKey = key;
	this.apiMsgContext[key] = contextObj;
};

com.inq.flash.client.control.CMSDKAppController.prototype.getApiContext = function(key) {
	var contextObj = this.apiMsgContext[key];
	return contextObj;
};

com.inq.flash.client.control.CMSDKAppController.prototype.getChatRouterMessages = function(callback) {
	this.setApiContext(com.inq.flash.client.control.CMSDKAppController.CRMESSAGES, {cb:callback});
	if (!this.persistentReconnect) {
		this.framework.getMessages();
		this.skinControl.clearTranscriptArray();
	}
};

com.inq.flash.client.control.CMSDKAppController.prototype.onNewChatRouterQuietMessage = function(reconnect) {
	if (reconnect) {
		this.notifyOnPreloaded();
	}
};

com.inq.flash.client.control.CMSDKAppController.prototype.notifyOnPreloaded = function() {
	if (this.framework.selectedConnectionHandler.processMessageQueue.length == 0) {
		this.onPreloadComplete("success");
	}
}

com.inq.flash.client.control.CMSDKAppController.prototype.onNewChatRouterMessage = function(message) {
	var contextObj;
	if ((this.persistentReconnect && message.data["chat.replay"] == "1") || this.chat.isAsyncReconnect()) {
		this.preloadMsgArray.push(message);
		if (message.data.messageType == "chat.communication") {
			this.seqNo += 1;
		}
		this.notifyOnPreloaded(true);
	} else {
		contextObj = this.getApiContext(com.inq.flash.client.control.CMSDKAppController.CRMESSAGES);
		if (contextObj && contextObj.cb) {
			if (message.data.messageType == "chat.communication") {
				this.seqNo += 1;
			}
			contextObj.cb(message);
		}
	}
};

com.inq.flash.client.control.CMSDKAppController.prototype.onLostConnection = function(){
	this.skinControl.connectionLostClosingChat();
};

com.inq.flash.client.control.CMSDKAppController.prototype.close = function () {
	this.disable();
	this.customerEngaged = false;
};

com.inq.flash.client.control.CMSDKAppController.prototype.closeChat = function() {
	if (this.customerClosesPopup()) {
		this.sendChatExitMsg(null, "closeChat");
	}
	this.disable();
	com.inq.flash.client.control.FlashPeer.onBeforeChatClosed();
	if (Application.application.getPreventChatClosed()) {
		com.inq.flash.client.control.FlashPeer.endChatSession(this.chat.getChatID());
		Application.application.setPreventChatClosed(false);
		com.inq.flash.client.chatskins.SkinControl.startPostChatTimer();
		this.msgcntAtEntry = 0;
	} else {
		this.prepareClosing();
		com.inq.flash.client.control.FlashPeer.closeChat(this.isConnected());

		if (com.inq.flash.client.control.FlashPeer.isPersistentWindow()) {
			window.parent.close();
		}
	}

	this.customerEngaged = false;
	this.shutdownQuietly();
};

com.inq.flash.client.control.CMSDKAppController.prototype.prepareClosing = function() {
	var chatID = this.chat.getChatID();
	com.inq.flash.client.control.FlashPeer.endChatSession(chatID);
	com.inq.flash.client.control.PersistenceManager.ClearValues();
	com.inq.flash.client.control.PersistenceManager.Close();
	com.inq.flash.client.chatskins.SkinControl.StopTimer();
	com.inq.flash.client.control.PersistenceManager.SetValue(MINIMIZED_COUNT, -1);
	this.msgcntAtEntry = 0;
};

com.inq.flash.client.control.CMSDKAppController.prototype.sendCustomerMessage = function(text) {
	var msg = this.getMessage(text);
	this.sendChatCommunicationMessage(msg, ++this.seqNo);
	this.msgcntAtEntry++;
};

com.inq.flash.client.control.CMSDKAppController.prototype.getMessage = function(text, sequence) {
	var message = new com.inq.flash.client.data.ChatCommunicationMessage(this.chat, text, this.isUpdateUsername());
	if (this.isUpdateUsername()) {
		this.cancelUpdateUsername();
	}
	return message;
};
com.inq.flash.client.control.CMSDKAppController.prototype.sendMessageOrQueue = function(message , clientTime, successListener, errorListener) {
	if (!this.queueMessages) {
		this.sendMessage(message, successListener, errorListener);
	} else {
		/** @type {number} */
		var now = clientTime == null ? new Date().getTime() : clientTime;
        this.messageQueue.push({"clientTime": now, "msg": message});
	}
};

com.inq.flash.client.control.CMSDKAppController.prototype.chatActivity = function(activity) {
	if (activity == "startTyping") {
		this.getTypingActivity(true);
		if (this.msgcntAtEntry < 1 && !this.customerEngaged) {
			window.setTimeout(com.inq.flash.client.control.Incrementality.onEngaged, 0);
			this.customerEngaged = true;
		}
	} else if (activity == "stopTyping") {
		this.getTypingActivity(false);
	} else if (activity == "minimize") {
		this.sendMinimizedMessage();
		com.inq.flash.client.chatskins.SkinControl.fireCustomEvent("ChatMinimized");
		com.inq.flash.client.control.PersistenceManager.SetValue(MINIMIZED_COUNT, 0);
		this.minimized = true;
	} else if (activity == "restore") {
		this.sendRestoredMessage();
		com.inq.flash.client.chatskins.SkinControl.fireCustomEvent("ChatRestored");
		this.minimized = false;
		com.inq.flash.client.control.MinimizeManager.restore();
	}
};
com.inq.flash.client.control.CMSDKAppController.prototype.getTypingActivity = function(activity) {
	var msgcnt = com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT, 0);
	if (this.firstMessageSent || msgcnt > 0) {
		var message = activity ? new com.inq.flash.client.data.ChatActivityMessage(this.chat, com.inq.flash.client.data.MessageFields.ACTIVITY_CUSTOMER_TYPING, null, null)
			: new com.inq.flash.client.data.ChatActivityMessage(this.chat, com.inq.flash.client.data.MessageFields.ACTIVITY_CUSTOMER_STOPS_TYPING, null, null);
		this.sendMessageOrQueue(message);
	}
};

com.inq.flash.client.control.CMSDKAppController.prototype.sendRichMessage = function (text, data, engagedCallback) {
	var msgcnt = com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT, 0);
	var message = new com.inq.flash.client.data.ChatCommunicationRichMessage(this.chat, text, this.isUpdateUsername(), data);
	if (msgcnt > 0) {
		this.sendMessageOrQueue(message);
	} else if (!this.isChatInProgress() && !this.framework.isConnected()) {
		this.engageAndSendMessage(message, engagedCallback);
	}
};

com.inq.flash.client.control.CMSDKAppController.prototype.engageAndSendMessage = function (message, engagedCallback, messageText) {
	this.queueMessages = true;
	this.sendText(message);
	this.engage(messageText || "", false, null, engagedCallback);
};

com.inq.flash.client.control.CMSDKAppController.prototype.persistentFrameReconnect = function() {
	if (!this.attemptingConnection) {
		this.attemptingConnection = true;
		this.queueMessages = true;
		/** @type {number} */
		var count = com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT, 0);
		this.framework.setParam("count", count);
		this.persistentReconnect = true;
		this.chatRouterListen = false;
		this.framework.connect();
	}
};
/**
 *
 * @param {function} preloadCb
 * @param {function} failedCb
 * @param {function} timeoutCb
 * @param {function} autoConnectedCb
 * @param {boolean} reBindCallbacks - When as Async Chat is re-initialized, Application
 * instance is cleared and re-inited due to that the callbacks and skin config are lost
 */
com.inq.flash.client.control.CMSDKAppController.prototype.onChatShown = function(preloadCb, failedCb, timeoutCb, autoConnectedCb, reBindCallbacks) {
	this.preloadedCb = preloadCb;
	this.failedCb = failedCb;
	this.timeoutCb = timeoutCb;
	this.autoConnectedCb = autoConnectedCb;
	this.preloadMsgArray = [];
    if (reBindCallbacks) {
        return;
    }
   
	if (this.msgcntAtEntry > 0 && Boolean(com.inq.flash.client.control.FlashVars.isContinued())) {
		this.persistentFrameReconnect();
	} else {
		if (!com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()) {
			com.inq.flash.client.chatskins.SkinControl.setupTimeoutTimer();
		}
	}
};

com.inq.flash.client.control.CMSDKAppController.prototype.onPreloadComplete = function(status) {
	this.preloadedCb && this.preloadedCb(
	    {
            "messages": this.preloadMsgArray,
            "statusType": (status == "success" ? "complete" : "failed"),
            "httpStatus": (status == "success" ? 200 : 401),
            "windowId": com.inq.flash.client.control.FlashVars.getWindowId()
	    }
	);
	this.playQueueMessages();
	this.queueMessages = false;
};

com.inq.flash.client.control.CMSDKAppController.prototype.isChatInProgress = function() {
	return (this.msgcntAtEntry > 0 || com.inq.flash.client.control.PersistenceManager.GetValue(CHAT_ENGAGED, false));
};
/**
 *
 * @param {Event} event - click event
 * @param {function} custMsgCb - call back to pass customer message that should be displayed
 * @param {function} linkClickCb - when page should navigate to another url
 * @param {function} engagedCallback - when chat is engaged from opener va message
 * @return {boolean}
 */
com.inq.flash.client.control.CMSDKAppController.prototype.sendVALinkClicked = function(event, custMsgCb, linkClickCb, engagedCallback) {

	var eventTarget = event.target || event.srcElement;
	var el;

	//if any element (i.e. "IMG") is wrapped in "A", it should be handled in the same way.
	//thus we are looking for the nearest "A" and working with its data-attributes.
	if (eventTarget.tagName == "A") {
		el = eventTarget;
	} else {
		el = findEl(eventTarget, event.currentTarget);
	}

	function findEl(el, currTarget) {
		while (el.parentNode && el != currTarget) {
			el = el.parentNode;
			if (el.tagName === "A") {
				return el;
			}
		}
		return null;
	}

	if (!el) {
		return;
	}

	// according to Nuance's VA service specification 'data-vtz-jump' attr exists only at dialog links,
	// so we can determine these links by checking this attribute
	/** @type {string} */
	var vtzJump = el.getAttribute("data-vtz-jump");

	// according to Nuance's VA service specification external web links contains
	// "data-vtz-link-type" attribute equal to “Web”,
	// and "data-vtz-browse" attr with URL inside.
	/** @type {string} */
	var linkType = el.getAttribute("data-vtz-link-type");
	/** @type {string} */
	var vtzBrowse = el.getAttribute("data-vtz-browse");
	/** @type {string} */
	var text;
	/** @type {boolean} */
	var hiddenMessage = false;

	var isVoid = el.href.startsWith("javascript:");

	if (linkType == "Web" && vtzBrowse) {
		// according to Nuance's VA service specification for links with 'data-vtz-browse' attr,
		// in addition to this navigation, the caller should call the web service sending “##Url#url value” as the UserText
		text = "##Url#" + vtzBrowse;
		hiddenMessage = true;
		// per RTDEV-21637, TalkAgentRequest.UserText should be limited to 100 chars.
		text = text.substring(0, 100);
		if (linkClickCb && !isVoid) {
			event.preventDefault ? event.preventDefault() : (event.returnValue = false);
			linkClickCb(el);
		}

		/**
		 * Some clients do not want us to notify the Virtual Agent when a user clicks a link that
		 * the Virtual Agent sent, because the Virtual Agent will then immediately respond with
		 * another a message, and since the user is switching pages and won't have a chance to listen
		 * to the response, it will cause an ARIA violation.
		 * Configured in uiconfig.json -> skinConfig.ninaLinkMessages
		 * Default is true.
		 * See NCI-1803.
		 */
		var ninaLinkMessages = com.inq.utils.Util.getConfig("ninaLinkMessages", true);

		if (!ninaLinkMessages) {
			return;
		}
	} else if (linkType == "Dialog") {
		text = el.text;
		custMsgCb && custMsgCb(text);
		event.preventDefault ? event.preventDefault() : (event.returnValue = false);
	} else if (event.type == "touchend" && event.target.href && event.target.href != "" && !isVoid) {
		event.preventDefault();
		/* A timeout is necessary here, because a simultaneous call to VA and url change is resulting in a network error when
		 communicating with VA and does a retry which sometimes is resulting in  duplicate requests. Note this is observed only iphones*/
		window.setTimeout(function() {
			if (linkClickCb) {
				linkClickCb(el);
			} else {
				window.parent.location.href = event.target.href;
			}
		}, 1000);

	}
	else {
		return false;
	}

	/** @type {com.inq.flash.client.data.ChatCommunicationMessage} */
	var  message = new com.inq.flash.client.data.ChatCommunicationMessage(this.chat,text);

	var elAttributes = el.attributes;
	for (var i = 0; i < elAttributes.length; i++) {
		var name = elAttributes[i].name;
		if (name.startsWith("data-vtz")) {
			message.addPropertyIfNotNull(name.replace("data-", ''), elAttributes[i].value);
		}
	}

	if (hiddenMessage) {
		message.addProperty(com.inq.flash.client.data.MessageFields.KEY_RETURN_RECEIPT, "0");
		message.addProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_DATA_HIDDEN_FOR_CUSTOMER, "true");
	}
	this.addPageDataToMessage(message);
	if (!this.isChatInProgress() && !this.framework.isConnected()) {
        this.engageAndSendMessage(message, engagedCallback);
    } else {
        this.sendChatCommunicationMessage(message, ++this.seqNo);
    }

};

com.inq.flash.client.control.CMSDKAppController.prototype.sendVAMessage = function(msgObj) {
	/** @type {com.inq.flash.client.data.ChatCommunicationMessage} */
	var  message = new com.inq.flash.client.data.ChatCommunicationMessage(this.chat,msgObj.text);

	var elAttributes = Object.keys(msgObj.attributes);
	for (var i = 0; i < elAttributes.length; i++) {
		var name = elAttributes[i];
		message.addPropertyIfNotNull(name, elAttributes[name]);
	}

	if (hiddenMessage) {
		message.addProperty(com.inq.flash.client.data.MessageFields.KEY_RETURN_RECEIPT, "0");
		message.addProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_DATA_HIDDEN_FOR_CUSTOMER, "true");
	}
	this.addPageDataToMessage(message);

	this.sendChatCommunicationMessage(message, ++this.seqNo);
};

com.inq.flash.client.control.CMSDKAppController.prototype.getOpenerScripts = function (responseCb) {

	// Skip opener scripts if we are in survey mode.
	if (com.inq.flash.client.control.FlashPeer.isCEAPIPostChatSurveyMode()) {
		return;
	}

	var opID = com.inq.flash.client.control.FlashVars.getValue("openerID");
	var opName = com.inq.flash.client.control.FlashVars.getValue("openerName");
	var siteID = com.inq.flash.client.control.FlashVars.getValue("siteID");

	if ((opID <= 0 && !opName) || !siteID) {
		responseCb([]);
		return;
	}

	this.setApiContext(com.inq.flash.client.control.CMSDKAppController.OPENER_S, responseCb);
	//RTDEV-4877 Added siteID parameter to load openers only from current site.
	//Also support loading by name. Name should be unique per new changes
	/** @type {string} */
	var sTagServerURL = Std.string(com.inq.flash.client.control.FlashVars.getValue("tagServerBaseURL"))
		+ "tagserver/scripts/getScript?js=yes&siteID=" + siteID;
	if (opName) {
		sTagServerURL += "&scriptName=" + Std.string(opName);
	} else {
		sTagServerURL += "&scriptID=" + Std.string(opID);
	}
	/** @type {string} */
	this.scriptLoader = new com.inq.net.URLLoader();
	/** @type {com.inq.net.URLRequest} */
	var scriptRequest = new com.inq.net.URLRequest(sTagServerURL);
	this.scriptLoader.addEventListener(com.inq.events.Event.NETWORK_ERROR, $bind(this, this.openerScriptFailed));
    this.scriptLoader.addEventListener(com.inq.events.Event.BAD_REQUEST, $bind(this, this.openerScriptFailed));
	this.scriptLoader.addEventListener(com.inq.events.Event.COMPLETE, $bind(this, this.openerScriptsLoaded));
	this.scriptLoader.load(scriptRequest);
};

com.inq.flash.client.control.CMSDKAppController.prototype.openerScriptsLoaded = function () {
	var sOpeners = this.scriptLoader.data;
	this.scriptLoader = null;
	/** @type {Xml} */
	var scriptXML = Xml.parse(sOpeners);
	/** @type {Iterator} */
	var it = scriptXML.firstElement().elements();
	/** @type {Array} */
	var aOpeners = new Array();
	var i = 0;
	while (it.hasNext()) {
		var x1 = it.next();
		/** @type {string} */
		var name = x1.getNodeName();
		if ("script" == name) {
			aOpeners[i++] = com.inq.flash.messagingframework.StringUtils.htmlEncode(x1.firstChild().toString());
		}
	}

	this.getApiContext(com.inq.flash.client.control.CMSDKAppController.OPENER_S)(aOpeners);
};

com.inq.flash.client.control.CMSDKAppController.prototype.openerScriptFailed = function () {
	this.getApiContext(com.inq.flash.client.control.CMSDKAppController.OPENER_S)([]);
};

/**
 * Sends System message that will not be part of transcript
 * @param {string} text
 */
com.inq.flash.client.control.CMSDKAppController.prototype.sendSystemMessage = function (text) {
	this.sendMessageOrQueue(new com.inq.flash.client.data.ChatCommunicationSystemMessage(this.chat, text, -1));
};

com.inq.flash.client.control.CMSDKAppController.CRMESSAGES = "chat.messages";
com.inq.flash.client.control.CMSDKAppController.OPENER_S = "openers";
